import type { OptionKV } from "~styled/selector/Selector";

export enum ENegocio {
  Prendarios = "Prendarios",
  MercadoAbierto = "MercadoAbierto",
  PAS = "PAS",
}

const TODOS = "";
export const PRENDARIOS = ENegocio.Prendarios;
export const MERCADO_ABIERTO = ENegocio.MercadoAbierto;
export const PAS = ENegocio.PAS;

const negociosSegurosOptions: Record<ENegocio | typeof TODOS, string> = {
  [TODOS]: "Todos",
  [PRENDARIOS]: "Prendarios",
  [MERCADO_ABIERTO]: "Mercado Abierto",
  [PAS]: "PAS",
};

const negociosSeguros: Record<
  ENegocio.Prendarios | ENegocio.MercadoAbierto,
  string
> = {
  [PRENDARIOS]: "Prendarios",
  [MERCADO_ABIERTO]: "Mercado Abierto",
};

const negocios: ENegocio[] = [PRENDARIOS, MERCADO_ABIERTO];

const negociosFilter: OptionKV<ENegocio | typeof TODOS>[] = [
  { label: negociosSegurosOptions[TODOS], value: TODOS },
  { label: negociosSegurosOptions[PRENDARIOS], value: PRENDARIOS },
  { label: negociosSegurosOptions[MERCADO_ABIERTO], value: MERCADO_ABIERTO },
];

export { negociosSegurosOptions, negocios, negociosSeguros, negociosFilter };
